/* Americanflat main product section — variant picker, price/availability
   updates, size visual depiction, quantity stepper, thumbnail gallery.

   Wires up every element with [data-af-product-root]. Reads:
     - data-af-atc-label  (text to show on the Add-to-cart button when available)
   The product JSON is read from a sibling/descendant <script
   data-af-product-json> tag. */
(function () {
  function moneyFmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function init(root) {
    const productJsonEl = document.querySelector('[data-af-product-json][data-section-id="' + root.dataset.sectionId + '"]')
      || root.querySelector('[data-af-product-json]');
    if (!productJsonEl) return;

    let product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      console.error('[af-main-product] Failed to parse product JSON', e);
      return;
    }

    const variantIdInput = root.querySelector('[data-af-variant-id]');
    const priceEl = root.querySelector('[data-af-price]');
    const atcBtn = root.querySelector('[data-af-atc]');
    const atcLabel = root.querySelector('[data-af-atc-label]');
    const atcLabelText = root.dataset.afAtcLabel || 'Add to cart';
    // Mobile sticky bar mirrors of price + add button (kept in sync on variant change).
    const stickyPriceEl = root.querySelector('[data-af-sticky-price]');
    const stickyBtn = root.querySelector('[data-af-sticky-add]');
    const stickyLabel = root.querySelector('[data-af-sticky-label]');

    // AJAX add-to-cart → open the cart drawer (when one is on the page).
    // Falls back to a normal form submit (→ /cart) if there's no drawer.
    const productForm = atcBtn && atcBtn.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return; // native submit
        e.preventDefault();
        if (atcBtn.hasAttribute('disabled')) return;

        // Re-resolve the variant from the live selection right before sending,
        // so the submitted id can never lag the chosen size/color.
        const chosen = findVariant(selectedValues());
        if (chosen && variantIdInput) variantIdInput.value = chosen.id;

        const original = atcLabel ? atcLabel.textContent : '';
        let confirmed = false;
        if (atcLabel) atcLabel.textContent = 'Adding…';
        atcBtn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(productForm);
          // Re-render just the cart-drawer section; the count badge is synced
          // separately via /cart.js below.
          fd.append('sections', 'cart-drawer');
          fd.append('sections_url', window.location.pathname);
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { Accept: 'application/javascript' }, body: fd,
          });
          const data = await res.json();
          if (data.status) { // e.g. sold out / not enough stock
            if (atcLabel) atcLabel.textContent = data.message || 'Unavailable';
            setTimeout(() => { if (atcLabel) atcLabel.textContent = original; }, 1500);
            return;
          }
          // Swap in the freshly rendered drawer markup, then open it the SAME
          // way the header cart icon does (a plain drawer.open()). Going through
          // Dawn's renderContents() — which swaps innerHTML and auto-opens on its
          // own setTimeout timing — is unreliable on Safari: it can leave the
          // drawer half-slid and showing stale/empty content. Mirroring the
          // proven cart-icon path fixes that across browsers.
          const sectionHTML = data.sections && data.sections['cart-drawer'];
          const live = document.querySelector('#CartDrawer');
          if (sectionHTML && live) {
            const fresh = new DOMParser()
              .parseFromString(sectionHTML, 'text/html')
              .querySelector('#CartDrawer');
            if (fresh) {
              live.innerHTML = fresh.innerHTML;
              drawer.classList.remove('is-empty');
              const overlay = live.querySelector('#CartDrawer-Overlay');
              if (overlay) overlay.addEventListener('click', () => drawer.close());
            }
          }
          // Force layout so Safari commits the new .drawer__inner's initial
          // (off-screen) transform before the slide-in class is applied.
          const inner = drawer.querySelector('.drawer__inner');
          if (inner) void inner.offsetWidth;
          drawer.open(atcBtn);
          confirmed = true;
          if (atcLabel) atcLabel.textContent = 'Added ✓';
          // Keep the header cart-count badge in sync.
          fetch('/cart.js').then((r) => r.json()).then((c) => {
            document.querySelectorAll('[data-af-cart-count]').forEach((el) => {
              el.textContent = c.item_count;
              el.hidden = c.item_count === 0;
            });
          }).catch(() => {});
        } catch (err) {
          productForm.submit(); // last-resort fallback
        } finally {
          atcBtn.removeAttribute('aria-busy');
          if (atcLabel) setTimeout(() => { atcLabel.textContent = original; }, confirmed ? 1600 : 600);
        }
      });
    }

    function selectedValues() {
      const out = [];
      root.querySelectorAll('input[type="radio"][data-af-option-index]:checked').forEach((r) => {
        out[parseInt(r.dataset.afOptionIndex, 10) - 1] = r.value;
      });
      return out;
    }

    // Normalize option values so a selected radio always resolves to its variant
    // even across formatting differences ('11" x 14"' vs '11x14', ×/x, casing).
    // A silent miss here is what left the default variant id in the form.
    function normOpt(s) {
      return String(s == null ? '' : s).toLowerCase().replace(/[″"']/g, '').replace(/\s+/g, '').replace(/×/g, 'x');
    }
    function findVariant(values) {
      // Single-variant products (no option pickers — e.g. "Default Title") render
      // no radios, so `values` is empty. Resolve to the lone variant instead of
      // failing, otherwise the on-load resolve would disable Add-to-cart.
      if (values.length === 0 && product.variants.length === 1) return product.variants[0];
      return product.variants.find((v) =>
        v.options.every((opt, i) => normOpt(opt) === normOpt(values[i]))
      );
    }

    // Variant picker cascades in OPTION ORDER. For an option value, find the best
    // matching variant while holding the options BEFORE it fixed to the current
    // selection and letting the options AFTER it float; prefer an available variant
    // (then one that also keeps the later current choices). This makes earlier
    // options "sticky": changing a later option (e.g. Pack) never rewrites an
    // earlier, deliberate choice (e.g. Colour), and changing an earlier option
    // cascades forward to re-pick the later ones. Handles both coupled options
    // (Hudson: Mat follows Size) and sparse grids (My Mini: most colours are
    // 1-pack only) without the old "snap to a different colour" surprise.
    function bestVariant(ci, val, cur) {
      const cands = product.variants.filter((v) => {
        if (normOpt(v.options[ci]) !== normOpt(val)) return false;
        for (let i = 0; i < ci; i++) {
          if (normOpt(v.options[i]) !== normOpt(cur[i])) return false;
        }
        return true;
      });
      if (!cands.length) return null;
      function score(v) {
        let s = v.available ? 1000 : 0;
        for (let i = ci + 1; i < v.options.length; i++) {
          if (normOpt(v.options[i]) === normOpt(cur[i])) s += 1;
        }
        return s;
      }
      cands.sort((a, b) => score(b) - score(a));
      return cands[0];
    }
    function resolveOnChange(ci, val) {
      const cur = selectedValues();
      cur[ci] = val;
      let target = bestVariant(ci, val, cur);
      if (!target) {
        // No variant carries this value with the earlier options held fixed. Tiles
        // for impossible values are hidden, so this is rare; fall back to any
        // variant with the value so we never leave an invalid combo selected.
        const any = product.variants
          .filter((v) => normOpt(v.options[ci]) === normOpt(val))
          .sort((a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0));
        if (!any.length) return;
        target = any[0];
      }
      const t = target.options;
      // Options up to & including the changed one already match the target, so
      // syncing radios only moves the LATER options — earlier choices stay put.
      root.querySelectorAll('input[type="radio"][data-af-option-index]').forEach((r) => {
        const i = parseInt(r.dataset.afOptionIndex, 10) - 1;
        if (normOpt(r.value) === normOpt(t[i])) r.checked = true;
      });
    }

    function updateSizeVisual(values) {
      const visual = root.querySelector('[data-af-size-visual]');
      if (!visual) return;
      const idx = parseInt(visual.dataset.afSizeOption, 10) - 1;
      const value = (values && values[idx]) || '';
      const m = value.match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/);
      if (!m) {
        visual.style.display = 'none';
        return;
      }
      visual.style.display = '';
      const w = parseFloat(m[1]);
      const h = parseFloat(m[2]);
      const widthPct = (w * 80) / 84;
      const frame = visual.querySelector('[data-af-size-frame]');
      if (frame) {
        frame.style.width = widthPct + '%';
        frame.style.aspectRatio = w + ' / ' + h;
      }
      const label = visual.querySelector('[data-af-size-label]');
      if (label) label.textContent = value + '"';
    }

    // Resize a Shopify CDN image URL to a target width via the ?width= param.
    function sizedUrl(src, w) {
      if (!src) return src;
      try {
        const u = new URL(src, window.location.href);
        u.searchParams.set('width', String(w));
        return u.toString();
      } catch (e) {
        return src;
      }
    }

    // Swap the main image (and sync the active thumbnail) to the selected
    // variant's featured image. No-op when the variant has no image assigned,
    // so size-only changes that share an image leave the gallery untouched.
    function updateVariantMedia(variant) {
      const fi = variant && variant.featured_image;
      if (!fi || !fi.src) return;
      // '#flat' in the image alt marks a lifestyle/scene shot: render
      // full-bleed with no float/shadow treatment, and strip the tag
      // from the visible alt text.
      const fiRawAlt = fi.alt || '';
      const fiIsFlat = fiRawAlt.indexOf('#flat') !== -1;
      const fiCleanAlt = fiRawAlt.replace('#flat', '').trim() || product.title || '';
      const box = root.querySelector('[data-af-main-image]');
      if (box) {
        const img = document.createElement('img');
        img.src = sizedUrl(fi.src, 1200);
        img.alt = fiCleanAlt;
        img.loading = 'eager';
        box.innerHTML = '';
        box.appendChild(img);
        box.classList.toggle('is-primary', !fiIsFlat);
      }
      let matched = null;
      const thumbs = root.querySelectorAll('[data-af-thumb-index]');
      thumbs.forEach((t) => {
        if (fi.id != null && t.dataset.afThumbImageId === String(fi.id)) matched = t;
      });
      if (matched) {
        thumbs.forEach((t) => t.classList.remove('active'));
        matched.classList.add('active');
      }
    }

    // STRICT per-combo cross-out: judge each value against the EXACT current
    // selection of the other options (this value swapped in). No variant for
    // that combo -> is-unavailable; an out-of-stock variant -> is-soldout. Both
    // render struck-through (CSS), not hidden. We don't snap other options, so
    // the cross-out reflects precisely "this value + what you've currently
    // chosen" (bidirectional). Values dead on EVERY variant are removed earlier
    // by hideDeadOptionValues(), so only buyable-somewhere values reach here.
    function updateOptionStates(values) {
      root.querySelectorAll('input[type="radio"][data-af-option-index]').forEach((r) => {
        const el = r.closest('.af-finish-opt, .af-size-tile');
        if (!el) return;
        const ci = parseInt(r.dataset.afOptionIndex, 10) - 1;
        const candidate = values.slice();
        candidate[ci] = r.value;
        const v = findVariant(candidate);
        el.classList.toggle('is-unavailable', !v);
        el.classList.toggle('is-soldout', !!v && !v.available);
      });
    }

    // Hide option values that are sold out in EVERY combination (true "zombie"
    // values), so dead sizes/colours/packs don't appear in the picker. A value
    // that's only unavailable in the CURRENT selection stays visible (greyed)
    // so the shopper can still pivot to a colour/pack that does carry it.
    function hideDeadOptionValues() {
      const liveByIndex = []; // per option index: Set of values on ≥1 available variant
      product.variants.forEach((v) => {
        if (!v.available) return;
        (v.options || []).forEach((opt, i) => {
          (liveByIndex[i] || (liveByIndex[i] = new Set())).add(normOpt(opt));
        });
      });
      root.querySelectorAll('input[type="radio"][data-af-option-index]').forEach((r) => {
        const idx = parseInt(r.dataset.afOptionIndex, 10) - 1;
        const live = liveByIndex[idx];
        if (live && live.has(normOpt(r.value))) return; // available somewhere → keep
        const tile = r.closest('.af-finish-opt, .af-size-tile');
        if (tile) {
          tile.classList.add('af-tile-dead');
          tile.style.display = 'none';
        }
      });
    }

    // Variant-aware "Product details" spec bullets. Per-variant specs come from a
    // JSON island ([data-af-spec-data]) keyed by variant id; on each variant change
    // rewrite the size / finish / mat bullet text from the selected variant.
    const afSpecData = (function () {
      const el = root.querySelector('[data-af-spec-data]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    })();
    function updateSpec(variant) {
      if (!afSpecData || !variant) return;
      const d = afSpecData[variant.id] || afSpecData[String(variant.id)];
      if (!d) return;
      const sizeEl = root.querySelector('[data-af-spec-size]');
      const finishEl = root.querySelector('[data-af-spec-finish]');
      const matEl = root.querySelector('[data-af-spec-mat]');
      if (sizeEl && d.size) sizeEl.textContent = d.size;
      if (finishEl) finishEl.textContent = [d.color, d.material].filter(Boolean).join(' · ');
      if (matEl) {
        if (d.mat) matEl.textContent = 'Matted to ' + d.mat;
        else if (d.matting && !/^(un|no )/i.test(d.matting)) matEl.textContent = d.matting;
      }
    }

    // Reorder the size grid: keep the collapsed best-sellers (non-extra tiles)
    // in their curated order first, then sort the remaining "Show all" tiles
    // ascending by parsed W x H (width, then height). Values with no parseable
    // dimensions sort to the end.
    function sortExtraSizesAscending() {
      const parseDims = (tile) => {
        const txt = (tile.querySelector('.dim') || {}).textContent || '';
        const m = txt.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        return m ? [parseFloat(m[1]), parseFloat(m[2])] : [Infinity, Infinity];
      };
      root.querySelectorAll('[data-af-size-grid]').forEach((grid) => {
        const tiles = Array.from(grid.querySelectorAll('.af-size-tile'));
        const collapsed = tiles.filter((t) => !t.classList.contains('af-size-tile--extra'));
        const extra = tiles.filter((t) => t.classList.contains('af-size-tile--extra'));
        extra.sort((a, b) => {
          const A = parseDims(a); const B = parseDims(b);
          return (A[0] - B[0]) || (A[1] - B[1]);
        });
        collapsed.concat(extra).forEach((t) => grid.appendChild(t));
      });
    }

    function updateUI(opts) {
      const initial = opts && opts.initial;
      const values = selectedValues();
      const variant = findVariant(values);

      updateOptionStates(values);

      root.querySelectorAll('.af-finish-opt, .af-size-tile').forEach((el) => {
        const input = el.querySelector('input[type="radio"]');
        if (input) el.classList.toggle('active', input.checked);
      });
      // Mirror the chosen swatch's name beside the COLOR legend (shown on mobile).
      root.querySelectorAll('.af-finish-list--swatch').forEach((list) => {
        const checked = list.querySelector('input[type="radio"]:checked');
        const sec = list.closest('.af-pdp-section');
        const head = sec && sec.querySelector('[data-af-finish-selected]');
        if (head) head.textContent = checked ? checked.value : '';
      });
      updateSizeVisual(values);

      if (!variant) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        if (stickyLabel) stickyLabel.textContent = 'Unavailable';
        return;
      }
      // Keep the submitted variant id in lockstep with the current selection.
      if (variantIdInput) variantIdInput.value = variant.id;

      // Refresh the Product-details spec bullets for the selected variant.
      updateSpec(variant);

      // Don't yank the gallery on first paint — only swap media on user changes.
      if (!initial) updateVariantMedia(variant);

      if (priceEl) {
        priceEl.innerHTML = moneyFmt(variant.price);
      }
      if (stickyPriceEl) stickyPriceEl.textContent = moneyFmt(variant.price);

      if (atcBtn) atcBtn.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? atcLabelText : 'Sold out';
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = variant.available ? atcLabelText : 'Sold out';

      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    root.querySelectorAll('input[type="radio"][data-af-option-index]').forEach((r) => {
      r.addEventListener('change', () => {
        // No auto-snap: the shopper's click stays put and the OTHER options
        // re-evaluate + cross out (bidirectional). updateOptionStates() inside
        // updateUI() strikes anything not buyable for the new selection.
        updateUI();
      });
    });

    // LEVEL 1: remove option values with no buyable variant anywhere (dead
    // everywhere) before first paint — a finish/size only shows if it's in
    // stock on at least one current variant.
    hideDeadOptionValues();

    // Non-best-seller sizes render ascending (smallest → largest); the collapsed
    // best-sellers keep their curated order up front.
    sortExtraSizesAscending();

    // Sync the hidden variant id / price / availability to the pre-checked
    // options on load. Previously this ran only on change, so the default
    // variant id could be submitted even after the shopper picked a size.
    updateUI({ initial: true });

    // Size "Show all sizes" expander — collapses extra tiles behind a toggle button.
    root.querySelectorAll('[data-af-size-toggle]').forEach((btn) => {
      const picker = btn.closest('.af-size-picker');
      const grid = picker && picker.querySelector('[data-af-size-grid]');
      if (!grid) return;
      const moreLabel = btn.querySelector('[data-af-size-more-label]');
      const total = grid.querySelectorAll('.af-size-tile:not(.af-tile-dead)').length;
      function syncLabel() {
        const collapsed = grid.classList.contains('is-collapsed');
        btn.setAttribute('aria-expanded', String(!collapsed));
        if (moreLabel) {
          moreLabel.textContent = collapsed ? 'Show all ' + total + ' sizes' : 'Show fewer sizes';
        }
      }
      btn.addEventListener('click', () => {
        grid.classList.toggle('is-collapsed');
        syncLabel();
      });
      // Always start collapsed on page load (no persisted/auto-expanded state).
      syncLabel();
    });

    const qtyInput = root.querySelector('[data-af-qty-input]');
    root.querySelectorAll('[data-af-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const delta = parseInt(btn.dataset.afQty, 10);
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + delta);
      });
    });

    const mainImageBox = root.querySelector('[data-af-main-image]');
    root.querySelectorAll('[data-af-thumb-index]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-af-thumb-index]').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.afThumbSrc;
        const alt = thumb.dataset.afThumbAlt;
        if (src && mainImageBox) {
          mainImageBox.innerHTML = '<img src="' + src + '" alt="' + (alt || '') + '" loading="eager">';
          // Only the primary (variant) frame shots get the floated 80% +
          // drop-shadow treatment; lifestyle/scene thumbnails stay full-bleed.
          mainImageBox.classList.toggle('is-primary', thumb.dataset.afThumbPrimary === 'true');
        }
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-af-product-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

/* Delivery estimate + order-cutoff countdown.
   Processing = business days (Mon–Fri; weekends skipped, holidays NOT).
   Transit  = business days added after the ship date (weekends skipped).
   If the order is placed before the cutoff hour (US Eastern) on a business
   day, processing starts that day; otherwise it starts the next business day.
   The "Order within" line counts down to that processing day's cutoff. */
(function () {
  const el = document.querySelector('[data-af-delivery]');
  if (!el) return;
  const dateEl = el.querySelector('[data-af-delivery-date]');
  const cdEl = el.querySelector('[data-af-delivery-countdown]');
  const processingBizDays = parseInt(el.dataset.processingDays, 10) || 0;
  const transitBizDays = parseInt(el.dataset.shippingDays, 10) || 0;
  const cutoffHour = parseInt(el.dataset.cutoffHour, 10);
  const hasCutoff = !isNaN(cutoffHour);
  const TZ = 'America/New_York';

  // "Now" expressed in Eastern time, as a Date we can do local arithmetic on.
  function easternNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
  }
  function isWeekend(d) { const g = d.getDay(); return g === 0 || g === 6; }
  function nextBusinessDay(d) {
    const n = new Date(d);
    do { n.setDate(n.getDate() + 1); } while (isWeekend(n));
    return n;
  }
  function addBusinessDays(d, n) {
    const r = new Date(d);
    let left = n;
    while (left > 0) { r.setDate(r.getDate() + 1); if (!isWeekend(r)) left--; }
    return r;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function render() {
    const now = easternNow();
    const today = new Date(now); today.setHours(0, 0, 0, 0);
    const nowMin = now.getHours() * 60 + now.getMinutes();
    const cutoffMin = hasCutoff ? cutoffHour * 60 : -1;

    // First business day processing begins on.
    let processingStart;
    if (hasCutoff && !isWeekend(today) && nowMin < cutoffMin) {
      processingStart = today;
    } else {
      processingStart = nextBusinessDay(today);
    }

    // Ship after N business days of processing, then N business days of transit.
    const shipDate = addBusinessDays(processingStart, processingBizDays);
    const deliver = addBusinessDays(shipDate, transitBizDays);
    if (dateEl) dateEl.textContent = 'Delivery by ' + fmtDate(deliver);

    if (cdEl && hasCutoff) {
      // Count down to the cutoff on the processing-start day.
      const target = new Date(processingStart); target.setHours(cutoffHour, 0, 0, 0);
      const totalMin = Math.max(0, Math.floor((target - now) / 60000));
      const days = Math.floor(totalMin / 1440);
      const hrs = Math.floor((totalMin % 1440) / 60);
      const mins = totalMin % 60;
      if (days > 0) cdEl.textContent = 'Order within ' + days + 'd ' + hrs + 'h';
      else if (hrs > 0) cdEl.textContent = 'Order within ' + hrs + ' hr ' + mins + ' min';
      else cdEl.textContent = 'Order within ' + mins + (mins === 1 ? ' min' : ' mins');
    } else if (cdEl) {
      cdEl.textContent = '';
    }
  }

  render();
  setInterval(render, 30000);
})();

/* Mobile sticky Add-to-cart bar — slides up once the main Add-to-cart row has
   scrolled ABOVE the viewport (i.e. the shopper scrolled past it), and hides
   again when it returns into view. CSS keeps the bar display:none on desktop. */
(function () {
  const bar = document.querySelector('[data-af-sticky-bar]');
  const cta = document.querySelector('.af-pdp-cta');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
      bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      // Lift the Klaviyo minimized teaser above the sticky bar so it doesn't
      // cover the Add-to-cart button (see .af-atc-visible rule in CSS).
      document.body.classList.toggle('af-atc-visible', scrolledPast);
    });
  }, { threshold: 0 });
  obs.observe(cta);
})();
